import React from "react";
import { toastError, toastSuccess } from "../toast";
import "./copyable-text.scss";

export const hasCopyValue = (value) => (
  value !== null && value !== undefined && String(value).trim() !== ""
);

export const copyTextToClipboard = async (value) => {
  const text = String(value);

  if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  if (typeof document === "undefined" || typeof document.execCommand !== "function") {
    throw new Error("Clipboard tidak didukung oleh browser.");
  }

  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "fixed";
  textArea.style.opacity = "0";
  textArea.style.pointerEvents = "none";

  document.body.appendChild(textArea);
  try {
    textArea.select();
    textArea.setSelectionRange(0, text.length);
    if (!document.execCommand("copy")) {
      throw new Error("Browser gagal menyalin nilai.");
    }
  } finally {
    document.body.removeChild(textArea);
  }
};

const CopyableText = ({ value, label }) => {
  if (!hasCopyValue(value)) return <span>-</span>;

  const handleCopy = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    try {
      await copyTextToClipboard(value);
      toastSuccess(`${label} disalin`, {
        autoClose: 1000,
        className: "copy-feedback-toast",
      });
    } catch (_error) {
      toastError(`Gagal menyalin ${label.toLowerCase()}`, {
        autoClose: 1800,
        className: "copy-feedback-toast",
      });
    }
  };

  return (
    <span className="copyable-text">
      <span className="copyable-text-value">{value}</span>
      <button
        type="button"
        className="copyable-text-button"
        onClick={handleCopy}
        title={`Salin ${label.toLowerCase()}`}
        aria-label={`Salin ${label.toLowerCase()}`}
      >
        <span className="material-icons-round" aria-hidden="true">content_copy</span>
      </button>
    </span>
  );
};

export default CopyableText;
